import type { AuditEntry } from "../types/audit";
import { useAuthStore } from "../stores/auth-store";

/**
 * Fire-and-forget audit log writer.
 * Sends an entry to the Electron main process via IPC.
 * No-ops silently when running in the browser (no `window.electron`).
 */
export function writeAuditLog(
  ltype: AuditEntry["ltype"],
  ctype: AuditEntry["ctype"],
  transactionType: number,
  sname: string,
  sresult: string,
): void {
  const username = useAuthStore.getState().user?.userName ?? "unknown";
  const entry: AuditEntry = {
    username,
    ltype,
    ctype,
    transactionType,
    sname,
    sresult,
    ts: new Date().toISOString(),
  };
  window.electron?.auditWrite?.(entry)?.catch(console.warn);
}
